import { Box, Stack, Typography, styled } from '@mui/material';

export const EventCardWrapper = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color: string }>(() => ({
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: '0.625rem',
  borderRadius: '0.625rem',
  background: '#fefefe',
  filter: 'drop-shadow(0px 1px 4px rgba(0,0,0,0.15))',
  paddingRight: '0.5rem',
  paddingTop: '0.5rem',
  paddingBottom: '0.5rem',
  cursor: 'pointer',
  flexShrink: 0,
  width: '100%',
  '&:hover': {
    background: '#F9F9FB',
  },
}));

export const SeverityBar = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color: string }>(({ color }) => ({
  width: '0.25rem',
  minHeight: '2.739rem',
  alignSelf: 'stretch',
  backgroundColor: color,
  borderRadius: '0 6.25rem 6.25rem 0',
  flexShrink: 0,
}));

export const CardTitle = styled(Typography)(() => ({
  color: '#615e6f',
  fontFamily: '"Neue Frutiger World"',
  fontSize: '0.75rem',
  fontWeight: 400,
  lineHeight: 1.6,
  flex: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const CardDescription = styled(Typography)(() => ({
  color: '#615e6f',
  fontFamily: '"Neue Frutiger World"',
  fontSize: '0.625rem',
  fontWeight: 400,
  lineHeight: 1.6,
  alignSelf: 'stretch',
  wordBreak: 'break-word',
}));

export const CardTime = styled(Typography)(() => ({
  fontSize: '0.75rem',
  color: '#615e6f',
  fontFamily: '"Neue Frutiger World"',
  fontWeight: 400,
  lineHeight: 1.6,
  flexShrink: 0,
  marginLeft: '0.5rem',
  whiteSpace: 'nowrap',
}));
